export const MAX_LENGTH = 50;
export const MAX_LIFETIME_IN_MINUTES = 10;
export const MAX_LIFETIME = 1000 * 60 * MAX_LIFETIME_IN_MINUTES;
